import { useTranslation } from "react-i18next";
import { Row, Col, Card, CardBody } from "react-bootstrap";
import crudApi from "@serie3/common/api/crudApi";
import { useEffect, useState } from "react";
import MessagesEndpoints from "@serie3/mymediaplanner/Modules/Messages/endpoints";
import { formatDate } from "@serie3/common/Shared/timeingStuff";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { isCurrentMonthAndYear } from "@serie3/common/Shared/timeingStuff";
import NewModal from "../../../shared/Modals/NewModal";
import CompleteDropdown from "../../../shared/Dropdown/CompleteDropdown";
import ConnectionRequestForm from "@serie3/mymediaplanner/Modules/Social/Forms/ConnectionRequestForm";
import { useFormik } from "formik";
import ConnectionRequest from "@serie3/mymediaplanner/Modules/Social/Entity/ConnectionRequest";
import TextField from "../../../Form/TextField";
import TextArea from "../../../Form/TextArea";
import NumberField from "../../../Form/NumberField";
import SaveButton from "../../../shared/Buttons/SaveButton";
import Checkbox from "../../../Form/Checkbox";
import listHandler from "@serie3/common/Domain/listHandler";
import SocialEndpoints from "@serie3/mymediaplanner/Modules/Social/endpoints";

const getMonthKey = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

const getMonthLabel = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return "";
  return d.toLocaleString("default", { month: "long", year: "numeric" });
};

const Requests = () => {
  const { t } = useTranslation();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sendThisMonth, setSendThisMonth] = useState([]);
  const [acceptanceRate, setAcceptanceRate] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [editRequest, setEditRequest] = useState();

  useEffect(() => {
    const fetchRequests = async () => {
      await crudApi.getAll(
        MessagesEndpoints.getSentRequests,
        setRequests,
        "requests"
      );
      setLoading(false);
    };
    fetchRequests();
  }, []);

  useEffect(() => {
    let monthCount = 0;
    let rejected = 0;

    requests.forEach((item) => {
      if (isCurrentMonthAndYear(item.send_date)) {
        monthCount++;
      }
      if (item.withdrawn) {
        rejected++;
      }
    });
    let acceptanceRate = 100 - Math.round((rejected / requests.length) * 100);
    setSendThisMonth(monthCount); // Update state after all items have been processed
    setAcceptanceRate(acceptanceRate);
  }, [requests]);

  const editConnectionRequestForm =
    ConnectionRequestForm.createConnectionRequestForm(
      requests,
      setRequests,
      setShowEdit
    );

  const formik = useFormik(editConnectionRequestForm);

  const Save = () => {
    return <SaveButton formik={formik} />;
  };
  return (
    <>
      <NewModal
        show={showEdit}
        title={t("Backend.Outreach.Connections.Requests.Modal.Title")}
        setShow={setShowEdit}
        onShow={() => {
          editRequest
            ? formik.setValues(ConnectionRequestForm.setEditData(editRequest))
            : formik.setValues(ConnectionRequest);
        }}
        onExit={() => {
          formik.resetForm({ values: { ConnectionRequest } });
        }}
        ExtraButton={Save}
      >
        <Row className="mb-1">
          <Col>
            <TextField
              formik={formik}
              valueName={"name"}
              label={t("Backend.Outreach.Connections.Requests.Modal.Name")}
            />
          </Col>
        </Row>
        <Row className="mb-1">
          <Col>
            <NumberField
              formik={formik}
              valueName={"follower"}
              step="1"
              label={t(
                "Backend.Outreach.Connections.Requests.Modal.Followercount"
              )}
            />
          </Col>
        </Row>
        <Row className="mb-1">
          <Col>
            <TextArea
              formik={formik}
              valueName={"bio"}
              label={t("Backend.Outreach.Connections.Requests.Modal.Bio")}
            />
          </Col>
        </Row>
        <Row className="mb-1">
          <Col>
            <Checkbox
              formik={formik}
              valueName={"withdrawn"}
              label={t("Backend.Outreach.Connections.Requests.Accepted")}
            />
          </Col>
        </Row>
      </NewModal>

      <h4 className="page-section-header">
        <span className="page-section-header-icon" style={{ background: "rgba(81,210,140,0.12)" }}>
          <FontAwesomeIcon icon={faUserPlus} style={{ color: "#51d28c" }} />
        </span>
        {t("Backend.Outreach.Connections.Requests.Title")}
      </h4>
      <Row className="mt-3">
        <Col md={4}>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-primary-subtle text-primary rounded-circle font-size-18">
                      <i className="uil uil-list-ul"></i>
                    </div>
                  </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1 text-truncate text-muted">
                    {t(
                      "Backend.Outreach.Connections.Requests.Stats.TotalRequests"
                    )}
                  </p>
                  <h5 className="font-size-16 mb-0">{requests.length}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col md={4}>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-primary-subtle text-primary rounded-circle font-size-18">
                      <i className="uil uil-list-ul"></i>
                    </div>
                  </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1 text-truncate text-muted">
                    {t(
                      "Backend.Outreach.Connections.Requests.Stats.TotalAcceptanceRate"
                    )}
                  </p>
                  <h5 className="font-size-16 mb-0">{acceptanceRate} %</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col md={4}>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-primary-subtle text-primary rounded-circle font-size-18">
                      <i className="uil uil-list-ul"></i>
                    </div>
                  </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1 text-truncate text-muted">
                    {t(
                      "Backend.Outreach.Connections.Requests.Stats.SendThisMonth"
                    )}
                  </p>
                  <h5 className="font-size-16 mb-0">{sendThisMonth}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Card>
        <CardBody>
          <Row>
            <Col>
              {loading ? (
                <div style={{ padding: "8px 0" }}>
                  {[1, 2, 3].map((i) => (
                    <div key={i} style={{ display: "flex", gap: 12, alignItems: "center", padding: "12px 0", borderBottom: "1px solid #f3f4f6" }}>
                      <div className="skeleton" style={{ width: 90, height: 14 }} />
                      <div className="skeleton" style={{ flex: 1, height: 14 }} />
                      <div className="skeleton" style={{ width: 70, height: 24, borderRadius: 20 }} />
                      <div className="skeleton" style={{ width: 30, height: 30, borderRadius: 8 }} />
                    </div>
                  ))}
                </div>
              ) : (
              <div className="table-responsive">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th style={{ width: 120 }}>Date</th>
                      <th>Name</th>
                      <th style={{ textAlign: "center", width: 120 }}>
                        {t("Backend.Outreach.Connections.Requests.Accepted")}
                      </th>
                      <th style={{ width: 60 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => { let lastMonthKey = null; return requests.map((item, index) => {
                      const monthKey = getMonthKey(item.send_date);
                      const showSeparator = monthKey && monthKey !== lastMonthKey;
                      lastMonthKey = monthKey;
                      return (
                        <>
                          {showSeparator && (
                            <tr key={`sep-${monthKey}`} className="month-separator-row">
                              <td colSpan={4}>
                                <span className="month-separator-label">{getMonthLabel(item.send_date)}</span>
                              </td>
                            </tr>
                          )}
                        <tr key={index}>
                          <td style={{ color: "#9299a8", whiteSpace: "nowrap" }}>{formatDate(item.send_date)}</td>
                          <td>
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noreferrer"
                              style={{ fontWeight: 600, color: "#038edc", textDecoration: "none" }}
                            >
                              {item.name}
                              {item.follower > 0 && (
                                <span style={{ fontWeight: 400, color: "#9299a8", fontSize: 12, marginLeft: 6 }}>
                                  ({item.follower})
                                </span>
                              )}
                            </a>
                            {item.bio && (
                              <p className="mb-0 mt-1" style={{ fontSize: 12, color: "#6b7280", whiteSpace: "pre-line" }}>
                                {item.bio}
                              </p>
                            )}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.withdrawn ? (
                              <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 10px", borderRadius: 20, background: "rgba(81,210,140,0.1)", color: "#2e9e65", fontSize: 12, fontWeight: 600 }}>
                                {t("Backend.Outreach.Connections.Requests.Accepted")}
                              </span>
                            ) : (
                              <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 10px", borderRadius: 20, background: "rgba(243,78,78,0.1)", color: "#f34e4e", fontSize: 12, fontWeight: 600 }}>
                                Pending
                              </span>
                            )}
                          </td>
                          <td>
                            <CompleteDropdown
                              editAction={() => {
                                setEditRequest(item);
                                setShowEdit(true);
                              }}
                              deleteAction={() => {
                                listHandler.deleteFromList(
                                  index,
                                  crudApi.del(
                                    SocialEndpoints.connections.delete,
                                    item.id
                                  ),
                                  setRequests,
                                  requests
                                );
                              }}
                            />
                          </td>
                        </tr>
                        </>
                      );
                    }); })()}
                  </tbody>
                </table>
              </div>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default Requests;
